export default __webpack_public_path__ + "static/media/bg-agent-1.9a83e841.png";